import React, {
  useState,
  ChangeEvent,
  useEffect,
  Dispatch,
  SetStateAction,
} from "react";
import {
  Dropdown,
  Label,
  Button,
  Input,
  Option,
  useRestoreFocusTarget,
  Toast,
  ToastTitle,
  ToastTrigger,
  Link,
  useId,
  useToastController,
  Tooltip,
  Field,
  Toaster,
  Checkbox,
  Popover,
  PopoverTrigger,
  PopoverSurface,
} from "@fluentui/react-components";
import { makeStyles, shorthands } from "@fluentui/react-components";
import { Tree } from "@fluentui/react-components/unstable";
import apiServices from "../../../service";
import { ChevronDown20Regular, Delete16Regular, Edit16Filled } from "@fluentui/react-icons";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { AppDispatch, RootState } from "../../../redux/store";
import { useDispatch, useSelector } from "react-redux";
import MaterialReactTable, {
  MRT_RowSelectionState,
} from "material-react-table";
import { setDialogModalOptions } from "../../../redux/modelDialogReducer";
import {
  convertHtmlToTextFormat,
  formatCondition,
  formatedDate2,
  isObjectEmpty,
} from "../../../utils";
import {
  Condition,
  ConditionType,
  Errors,
  TreeNode,
  ValidationErrors,
  booleanOperators,
  dateOperators,
  filterConditionalTypeData,
  filterTypeData,
  getDatatype,
  stringOperators,
  useStyles,
} from "../../../shared/extractTypes";
import OverlayLoader from "../../../components/OverlayLoader";
import { renderConditionTree, renderTree } from "./treeData";
import CreatableSelect from "react-select/creatable";
import { setUpdateSearch } from "../../../redux/SavedSearch/updateSearchId";
import { setSelectionType } from "../../../redux/SavedSearch/extractTypes";
import ASCButton from "../../../components/Button";
import NoDataFound from "../../../components/NoDataFound/noDataFound";
import DynamicDatePicker from "../../../components/ControlledDatePicker/dynamicDatepicker";
import ASCDropDown from "../../../components/DropDown";
import { setClientOrPartner, setconditionalClientOrPartner } from "../../../redux/clientSlice";

const tableColumnList = {
  extractList: [
    {
      accessorKey: "Title",
      header: "Title",
    },
    {
      accessorKey: "Description",
      header: "Description",
    },
    {
      accessorKey: "Condition",
      header: "Condition",
      Cell: ({ row }: any) => <>{formatCondition(row.original.Condition)}</>,
    },
  ],
};

type ExtractMainProps = {
  setIsDialogOpen: () => void;
  setTabOpen: () => void;
  appliedId: (id: string) => void;
  extract: { [key: string]: any }[];
  setExtract: Dispatch<SetStateAction<{ [key: string]: any }[]>>;
  getExtracts: () => void;
};

export const ExtractMain: React.FC<ExtractMainProps> = ({
  setIsDialogOpen,
  appliedId,
  extract,
  setExtract,
  getExtracts,
  setTabOpen,
}) => {
  const comboId = useId("combo-default");
  const [isDataLabel, setDataLabel] = useState<string>("");
  const [isConditionDataLabel, setIsConditionDataLabel] = useState<string>("");
  const [isDrodownExpand, setDropdownExpand] = useState(false);
  const [isDrodownExpanded, setDropdownExpanded] = useState(false);
  const [treeKey, setTreeKey] = useState(0);
  const [treeConditionKey, setTreeConditionKey] = useState(0);
  const dispatch: AppDispatch = useDispatch();
  const [extractData, setExtractData] = useState<TreeNode[]>([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [selectedFieldId, setSelectedFieldId] = useState("");
  const [selectConditionOption, SetSelectConditionOption] = useState("");
  const [titleData, setTitleData] = useState<any>("");
  const [fieldType, setFieldType] = useState<any>("");
  const [descriptionData, setDescriptionData] = useState<string>("");
  const [isDropdownOpen, setIsDropdownOpen] = useState<boolean>(false);
  const [isButtonDisabled, setIsButtonDisabled] = useState<boolean>(false);
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const [searchID, setSearchID] = useState<string>("");
  const restoreFocusTargetAttribute = useRestoreFocusTarget();
  const [showDialogPopup, setShowDialogPopup] = useState(false);

  const [selectFieldOptions, setSelectFieldOptions] = useState<any>([]);
  const [isFilteredDataType, setIsFilteredDataType] = useState<
    filterTypeData[]
  >([]);
  const [isConditionalFilteredDataType, setIsConditionalFilteredDataType] =
    useState<filterConditionalTypeData[]>([]);
  const [tableOne, setTableOne] = useState("");
  const [tableTwo, setTableTwo] = useState("");

  const [selectedOperator, setSelectedOperator] = useState("");
  const [selectedValue, setSelectedValue] = useState<any>("");
  const [selectedCondition, setSelectedCondition] = useState("");
  const [rowSelection, setRowSelection] = React.useState<MRT_RowSelectionState>(
    {},
  );
  const [operatorName, setOperatorName] = useState("");
  const [selectedConditionOperator, setSelectedConditionOperator] =
    useState("");
  const [selectedConditionValue, setSelectedConditionValue] = useState<any>("");
  const [loading, setLoading] = useState(false);
  const toasterId = useId("toaster");
  const { dispatchToast } = useToastController(toasterId);
  const [selectedRow, setSelectedRow] = useState<{
    [key: string]: any;
  }>({});
  const [mode, setMode] = useState("");
  const [validationErrors, setValidationErrors] = useState<ValidationErrors>(
    {},
  );
  const [conditionPopulation, setConditionPopulation] = useState<any[]>([]);
  const [clientDetail, setClientDetail] = useState<any[]>([]);
  const [checked, setChecked] = useState(false);
  const { userProfileInfo } = useSelector((state: any) => state.authUser);
  const [loadCreatable, setLoadCreatable] = useState<boolean>(false);
  const [loadCreatableCondition, setLoadCreatableConditon] =
    useState<boolean>(false);
  const clientpartner = useSelector(
    (state: any) => state.clientpartner.storedValue,
  );

  const conditionalClientPartner = useSelector(
    (state: any) => state.conditionalclientpartner.storedValue,
  );
  const flattenedOptions = React.useMemo(() => {
    const flatten = (data: TreeNode[], parentLabel: string = ""): any[] => {
      let flattened: any[] = [];
      data.forEach((node) => {
        if (node.items) {
          flattened = [...flattened, ...flatten(node.items, node.label || parentLabel)];
        } else {
          flattened.push({
            label: parentLabel ? `${parentLabel} > ${node.name || node.fieldName}` : (node.table === "UserDefinedValue" ? node.fieldName : node.name),
            value: node.fieldName + (node.table || ""), // Ensure unique value if fieldName repeats across tables
            actualValue: node.fieldName,
            parentLabel: parentLabel,
            node: node,
          });
        }
      });
      return flattened;
    };
    return flatten(extractData);
  }, [extractData]);

  const toggleDropdown = () => {
    setDropdownExpand((prevState) => !prevState);
    setTreeKey((prevKey) => prevKey + 1);
  };

  const toggleConditionDropdown = () => {
    setDropdownExpanded((prevState) => !prevState);
    setTreeConditionKey((prevKey) => prevKey + 1);
  };

  const changeMode = (mode: string, rowData?: any) => {
    setMode(mode);

    const editTarget = rowData || selectedRow;
    if (mode === "edit" && editTarget) {
      setSelectedRow(editTarget);
      let buildCondition = JSON.parse(editTarget.Condition);
      setTitleData(editTarget.Title);
      setDescriptionData(editTarget.Description);
      setTableOne(buildCondition?.tableOne?.table);
      setSelectedOption(buildCondition?.tableOne?.fieldName);
      setDataLabel(buildCondition?.tableOne?.label);
      setSelectedOperator(buildCondition?.tableOne?.condition);
      setSelectedValue(buildCondition?.tableOne?.fieldValue);
      setIsFilteredDataType(buildCondition?.tableOne?.fieldType || "");
      if (
        !editTarget.Condition ||
        isDeleted === true ||
        !buildCondition?.tableTwo
      ) {
        setTableTwo("");
        setIsConditionDataLabel("");
        SetSelectConditionOption("");
        setSelectedConditionOperator("");
        setSelectedConditionValue("");
        setSelectedCondition("");
        setIsConditionalFilteredDataType("" as any);
        return;
      }
      setTableTwo(buildCondition?.tableTwo?.table);
      setIsConditionDataLabel(buildCondition?.tableTwo?.label || "");
      SetSelectConditionOption(buildCondition?.tableTwo?.fieldName || "");
      setSelectedConditionOperator(buildCondition?.tableTwo?.condition || "");
      setSelectedConditionValue(buildCondition?.tableTwo?.fieldValue || "");
      setSelectedCondition(buildCondition?.condition || "");
      setIsConditionalFilteredDataType(buildCondition?.tableTwo?.fieldType || "");

      if (buildCondition?.tableTwo?.label != "") {
        setShowDialogPopup(true);
        setIsButtonDisabled(true);
      } else {
        setShowDialogPopup(false);
      }
    }
  };

  useEffect(() => {
    if (extract.length > 0) {
      if (mode === "" || isObjectEmpty(selectedRow)) {
        selectedIndex(0);
      } else if (mode === "view" && !extract.some((item) => item.SearchId === selectedRow.SearchId)) {
        selectedIndex(0);
      }
    }
  }, [extract, mode, selectedRow]);

  // Sync selectedRow with refreshed extract data after edit/delete
  useEffect(() => {
    if (!isObjectEmpty(selectedRow) && mode === "view") {
      const updated = extract.find((item: any) => item.SearchId === selectedRow.SearchId);
      if (updated && JSON.stringify(updated) !== JSON.stringify(selectedRow)) {
        setSelectedRow(updated);
      }
    }
  }, [extract]);

  const selectedIndex = (index: number) => {
    if (extract.length > 0) {
      setMode("view");
      setSelectedRow(extract[index]);
    }
  };
  useEffect(() => {
    if (!isObjectEmpty(selectedRow)) {
      const index = extract.findIndex(
        (item) => item.SearchId === selectedRow.SearchId,
      );
      setRowSelection({ [index]: true });
    }
  }, [selectedRow]);

  useEffect(() => {
    handleModifiedBySelection();
  }, []);

  const handleModifiedBySelection = async () => {
    try {
      const fieldLbl = "consultant_list:MasterDatawithoutNewEntry";

      const res = await apiServices.selectionList.getOptions(fieldLbl);
      if (res.data?.data?.[0]?.options) {
        // Extract labels from options
        const dropdownOptions = res.data.data[0].options.map((option: any) => ({
          value: option.value,
          label: option.label,
        }));

        setSelectFieldOptions(dropdownOptions);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const notify = (message: any, type?: any) =>
    dispatchToast(
      <Toast>
        <ToastTitle
          action={
            <ToastTrigger>
              <Link>Dismiss</Link>
            </ToastTrigger>
          }
        >
          {message}
        </ToastTitle>
      </Toast>,
      { intent: type ? type : "success" },
    );
  const getOperators = () => {
    switch (types.toString()) {
      case "number":
        return booleanOperators;
      case "string":
        return stringOperators;
      case "timestamp":
        return dateOperators;
      default:
        return [];
    }
  };
  const conditionDataType = isConditionalFilteredDataType;
  const getConditionOperators = () => {
    switch (conditionDataType.toString()) {
      case "number":
        return booleanOperators;
      case "string":
        return stringOperators;
      case "timestamp":
        return dateOperators;
      default:
        return [];
    }
  };

  const [isCondition, setIsCondition] = useState<ConditionType[]>(Condition);

  const handleTitleChange = (
    fieldName: string,
    event: ChangeEvent<HTMLInputElement>,
  ) => {
    const { value } = event.target;
    setTitleData(value);
    setValidationErrors((prevErrors) => ({
      ...prevErrors,
      titleData: "",
    }));
  };
  const handleDescriptionChange = (e: any, value: any) => {
    setDescriptionData(value.value);
  };
  const handleAddCondition = () => {
    setShowDialogPopup(true);
    setIsButtonDisabled(true);
  };
  const handleDeleteCondition = () => {
    setShowDialogPopup(false);
    setIsButtonDisabled(false);
    setIsDeleted(false);
    SetSelectConditionOption("");
    setSelectedConditionOperator("");
    setSelectedConditionValue("");
    setSelectedCondition("");
    setSelectedConditionOperator("");
  };
  const handleClose = () => {
    setShowDialogPopup(false);
    setIsButtonDisabled(false);
    setTitleData("");
    setDescriptionData("");
    setSelectedOption("");
    setSelectedFieldId("");
    setSelectedOperator("");
    setSelectedValue("");
    setDataLabel("");
    setIsConditionDataLabel("");
    SetSelectConditionOption("");
    setSelectedConditionOperator("");
    setSelectedConditionValue("");
    setSelectedCondition("");
    changeMode("view");
  };

  const handleTreeData = (e: any) => {
    setSelectedOption(e.target.value);
  };
  const handleOperator = (e: any, value: any) => {
    setSelectedOperator(value.optionValue);
  };
  const handleValue = (e: any, value: any) => {
    setSelectedValue(value.value);
  };
  const handleCondition = (e: any, value: any) => {
    setSelectedCondition(value.optionValue);
  };
  const handleConditionOperator = (e: any, value: any) => {
    setSelectedConditionOperator(value.optionValue);
  };
  const handleConditionValue = (e: any, value: any) => {
    setSelectedConditionValue(value.value);
  };
  const handleConditionTreeData = (e: any) => {
    SetSelectConditionOption(e.target.value);
  };
  const handleDropdownToggle = (isOpen: any) => {
    setIsDropdownOpen(isOpen);
  };

  const handleCheckboxChange = (event: any) => {
    setChecked(event.target.checked);
  };

  const getFormErrors = (): Errors => {
    const errors: Errors = {};
    if (!titleData.trim()) errors.titleData = "Title is required";
    if (!selectedOption) errors.selectedOption = "Field is required";
    if (selectedOption && !selectedOperator) {
      errors.selectedOperator = "Operator is required";
    }
    if (showDialogPopup && selectedCondition) {
      if (!selectConditionOption) {
        errors.selectConditionOption = "Field is required";
      }
      if (!selectedConditionOperator) {
        errors.selectedConditionOperator = "Operator is required";
      }
    }
    return errors;
  };
  const formErrors = getFormErrors();
  const hasErrors = Object.keys(formErrors).length > 0;

  const createExtract = async (shouldSetSearchID = false) => {
    const errors = getFormErrors();

    if (Object.keys(errors).length > 0) {
      setValidationErrors(errors);
      return;
    }

    const countFields = [
      "Investments",
      "Share Holdings",
      "Home and Personal",
      "Bank/Building Societies",
      "Mortgages",
      "Loan and Hire Purchases",
      "Credit Cards",
      "Life Assurance",
      "Pensions",
      "Investments",
      "Savings Plans",
      "Income Protection",
      "Health Assurance",
      "General",
    ];

    const tableOneCondition = {
      table: tableOne,
      fieldName: selectedOption,
      label: isDataLabel,
      fk: "CustomerId",
      fieldType: types.toString(),
      fieldValue:
        types.toString() === "timestamp"
          ? formatedDate2(selectedValue)
          : selectedValue,
      condition: selectedOperator,
      ...(countFields.includes(isDataLabel)
        ? { count: true, caseTypeField: "CaseType" }
        : {}),
      partner:
        clientpartner === "Client"
          ? false
          : clientpartner === "Partner"
            ? true
            : "",
    };

    const tableTwoCondition = {
      table: tableTwo,
      fieldName: selectConditionOption,
      fk: "CustomerId",
      fieldType: conditionDataType.toString(),
      label: isConditionDataLabel,
      fieldValue:
        conditionDataType.toString() === "timestamp"
          ? formatedDate2(selectedConditionValue)
          : selectedConditionValue,
      condition: selectedConditionOperator,
      ...(countFields.includes(selectConditionOption)
        ? { count: true, caseTypeField: "CaseType" }
        : {}),
      partner:
        conditionalClientPartner === "Client"
          ? false
          : conditionalClientPartner === "Partner"
            ? true
            : "",
    };

    const newData = {
      type: "Condition",
      title: titleData,
      description: descriptionData,
      condition: {
        tableOne: tableOneCondition,
        ...(selectedCondition && {
          tableTwo: tableTwoCondition,
        }),
        condition: selectedCondition,
      },
      UserId: !checked ? userProfileInfo.user_id : null,
    };

    try {
      setLoading(true);

      let response;
      if (mode === "add") {
        response = await apiServices.extract.add(newData);
      } else {
        response = await apiServices.extract.update(
          selectedRow.SearchId,
          newData,
        );
      }

      if (response.data) {
        notify(response.data.message, "success");

        if (shouldSetSearchID) {
          const newSearchId = mode === "edit"
            ? selectedRow.SearchId
            : response.data.data.SearchId;
          setSearchID(newSearchId);
          dispatch(setUpdateSearch(newSearchId));
          dispatch(setSelectionType(response.data.data?.Type || "Condition"));
          return newSearchId;
        }

        getExtracts();
        return true;
      } else {
        notify("Something went wrong", "error");
        return false;
      }
    } catch (error) {
      console.log("error", error);
      return false;
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    const success = await createExtract(false);
    if (success) {
      handleClose();
    }
  };

  const handleSaveAndApply = async () => {
    const newSearchId = await createExtract(true);
    if (newSearchId) {
      getExtracts();
      handleClose();
      appliedId(newSearchId);
    }
  };

  const handleOptionClick = (
    value: any,
    label: any,
    itemType: string,
    datatypes: any,
    datatype: any,
    table: any,
    fieldName?: any,
    node?: any,
  ) => {
    setTableOne(table);
    setSelectedOption(fieldName);
    setSelectedFieldId(node?.id || "");
    setIsFilteredDataType(datatype === "integer" ? "number" : datatype);
    setDropdownExpand(false);
    setDataLabel(table == "UserDefinedValue" ? fieldName : label);
  };

  const handleConditionOptionClick = (
    value: any,
    label: any,
    itemType: string,
    data: any,
    datatype: any,
    table: any,
    fieldName?: any,
    node?: any,
  ) => {
    setTableTwo(table);
    setOperatorName(label);
    SetSelectConditionOption(fieldName);
    setSelectedFieldId(node?.id || "");
    setIsConditionalFilteredDataType(
      datatype === "integer" ? "number" : datatype,
    );
    setDropdownExpanded(false);
    setIsConditionDataLabel(label);
  };
  const styles = useStyles();
  const getExtractList = async () => {
    try {
      const response = await apiServices.extract.getList();
      const data: any = response.data;
      // Deep clean: removes ALL "Modified" and "Modified By" fields everywhere
      const removeModifiedFields = (items: any[]): any[] => {
        return items
          .filter((item: any) => {
            const name = (item.name || "").toString().trim();
            const fieldName = (item.fieldName || "").toString().trim();

            // Remove if name or fieldName matches "Modified" or "Modified By"
            return !(
              name === "Modified" ||
              name === "Modified By" ||
              fieldName === "Modified" ||
              fieldName === "ModifiedBy"
            );
          })
          .map((item: any) => {
            // If this item has nested items (like Employment Benefits, Vulnerability, etc.)
            if (item.items && Array.isArray(item.items)) {
              return {
                ...item,
                items: removeModifiedFields(item.items),
              };
            }
            return item;
          });
      };

      // Apply to every top-level section
      const cleanedData = data.map((section: any) => ({
        ...section,
        items: removeModifiedFields(section.items || []),
      }));

      setExtractData(cleanedData);
    } catch (error) {
      console.error("Failed to fetch extract list:", error);
    }
  };

  const deleteData = (row: any) => {
    setLoading(true);
    apiServices.extract
      .delete(row.SearchId)
      .then((response: any) => {
        setLoading(false);
        notify(response.data.message, "success");
        getExtracts();
        dispatch(setDialogModalOptions({ open: false }));
      })
      .catch((e: Error) => {
        setLoading(false);
        dispatch(setDialogModalOptions({ open: false }));
      });
  };

  const getClientDetails = (tableName: any, columnName: any) => {
    setLoadCreatable(true); // Start loading
    apiServices.extract
      .getClientList(tableName, columnName)
      .then((response: any) => {
        if (!response.data.isError) {
          if (response.data[0].options) {
            const cleanedOptions = response.data[0].options.map((opt: any) => ({
              ...opt,
              label: convertHtmlToTextFormat(opt.label),
              value: convertHtmlToTextFormat(opt.value),
            }));

            setClientDetail(cleanedOptions);
          }
        }
      })
      .catch((e: Error) => {
        console.error("API Error:", e);
      })
      .finally(() => {
        setLoadCreatable(false); // Stop loading
      });
  };
  useEffect(() => {
    const tableName = tableOne;
    const columnName = selectedOption;
    let fieldId = selectedFieldId;

    if (tableName && columnName) {
      if (tableName == "UserDefinedValue" && fieldId) {
        getClientDetails(tableName, fieldId);
      } else {
        getClientDetails(tableName, columnName);
      }
    } else {
      console.warn("Missing parameters: Table or Column");
    }
  }, [tableOne, selectedOption]);

  const conditionDataPopulation = (tableName: any, columnName: any) => {
    setLoadCreatableConditon(true); // Start loading
    apiServices.extract
      .getClientList(tableName, columnName)
      .then((response: any) => {
        if (!response.data.isError) {
          if (response.data[0].options) {
            setConditionPopulation(response.data[0].options);
          }
        }
      })
      .catch((e: Error) => {
        console.error("API Error:", e);
      })
      .finally(() => {
        setLoadCreatableConditon(false); // Stop loading
      });
  };
  useEffect(() => {
    const tableName = tableTwo;
    const columnName = selectConditionOption;
    let fieldId = selectedFieldId;

    if (tableName && columnName) {
      if (tableName == "UserDefinedValue" && fieldId) {
        conditionDataPopulation(tableName, fieldId);
      } else {
        conditionDataPopulation(tableName, columnName);
      }
    } else {
      console.warn("Missing parameters: Table or Column");
    }
  }, [tableTwo, selectedCondition]);

  const types = isFilteredDataType;
  useEffect(() => {
    getExtractList();
    getExtracts();
  }, []);
  const handleSelectDate = (date: Date | string | null | undefined) => {
    if (date) {
      setSelectedValue(date);
    }
  };
  const handleSelectConditionDate = (
    date: Date | string | null | undefined,
  ) => {
    if (date) {
      setSelectedConditionValue(date);
    }
  };

  const formatDate = (date: Date | undefined) => {
    if (!date) return "";
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };
  return (
    <>
      <OverlayLoader isLoading={loading} />
      <Toaster
        toasterId={toasterId}
        position="top-end"
        pauseOnHover
        pauseOnWindowBlur
        timeout={1000}
      />
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          // minHeight: "600px",
          maxHeight: "600px",
        }}
      >
        <div
          className={styles.Addbutton}
          style={{ display: "flex", justifyContent: "end" }}
        >
          <ASCButton
            shape="rounded"
            style={{ backgroundColor: "#0f6cbd" }}
            appearance="primary"
            className="asc-button-primary"
            {...restoreFocusTargetAttribute}
            onClick={() => {
              changeMode("add");
            }}
            disabled={mode === "add"}
            label="Add Search"
          />
        </div>
        {extract.length > 0 ? (
          <div>
            <div className="extract-form">
              {mode === "view" && (
                <div className="grid-container">
                  {selectedRow && (
                    <>
                      <div className="fieldWrapper">
                        <Label weight="semibold" size="medium">
                          Title
                        </Label>
                        <Label>{selectedRow.Title}</Label>
                      </div>
                      <div className="fieldWrapper">
                        <Label weight="semibold" size="medium">
                          Description
                        </Label>
                        <Label>{selectedRow.Description}</Label>
                      </div>
                      <div className="fieldWrapper">
                        <Label weight="semibold" size="medium">
                          Condition
                        </Label>
                        <Label>{formatCondition(selectedRow.Condition)}</Label>
                      </div>
                    </>
                  )}
                </div>
              )}
              {(mode === "add" || mode === "edit") && (
                <div>
                  <h3>{mode === "add" ? "Add Search" : "Edit Search"}</h3>
                  <div
                    style={{
                      margin: "10px 0",
                      display: "grid",
                      gridTemplateColumns: "1fr 1fr",
                      gap: "10px",
                    }}
                  >
                    <Field
                      label={
                        <span>
                          Title<span className="required-item">*</span>
                        </span>
                      }
                      validationState={
                        validationErrors.titleData ? "error" : "none"
                      }
                      validationMessage={validationErrors.titleData || ""}
                    >
                      <Input
                        value={titleData}
                        name="titleData"
                        onChange={(e) => {
                          handleTitleChange("titleData", e);
                          setValidationErrors({
                            ...validationErrors,
                            titleData: "",
                          });
                        }}
                      />
                    </Field>

                    <Field label="Description">
                      <Input
                        value={descriptionData}
                        name="descriptionData"
                        onChange={handleDescriptionChange}
                      />
                    </Field>
                  </div>
                  <div className={styles.inlineContainer}>
                    <Field label="Field">
                      <Dropdown
                        open={isDrodownExpand}
                        onClick={toggleDropdown}
                        name="selectedOption"
                        onOptionSelect={handleTreeData}
                        placeholder={isDataLabel || "Field"}
                        onOpenChange={handleDropdownToggle}
                        className="custom-dropdown"
                      >
                        <Tree
                          aria-label="Dynamic Tree"
                          key={treeKey}
                          className="custom-tree"
                        >
                          {renderTree(extractData, handleOptionClick)}
                        </Tree>
                      </Dropdown>
                    </Field>

                    <Field
                      label={
                        <span>
                          Operator
                          {((Array.isArray(selectedOption) &&
                            selectedOption.length > 0) ||
                            (typeof selectedOption === "string" &&
                              selectedOption) ||
                            (typeof selectedOption === "number" &&
                              selectedOption !== 0)) && (
                              <span className="required-item">*</span>
                            )}
                        </span>
                      }
                      validationState={
                        validationErrors.selectedOperator ? "error" : "none"
                      }
                      validationMessage={
                        validationErrors.selectedOperator || ""
                      }
                    >
                      <Dropdown
                        name="selectedOperator"
                        placeholder={selectedOperator || "Operator"}
                        onOptionSelect={(e, value) => {
                          handleOperator(e, value);
                          setValidationErrors({
                            ...validationErrors,
                            selectedOperator: "",
                          });
                        }}
                      >
                        {getOperators().map((opt) => (
                          <Option key={opt.value} value={opt.value}>
                            {opt.label}
                          </Option>
                        ))}
                      </Dropdown>
                    </Field>
                    <Field label={<span>Value</span>}>
                      {types.toString() === "timestamp" ? (
                        <DynamicDatePicker
                          border
                          name="selectedValue"
                          label={null}
                          required={false}
                          disabled={false}
                          formik={{
                            values: {
                              selectedValue: selectedValue
                                ? new Date(selectedValue)
                                : null,
                            },
                            setFieldValue: (
                              _name: string,
                              value: Date | null,
                            ) => {
                              handleSelectDate(value);
                            },
                            setFieldTouched: () => { },
                            setFieldError: () => { },
                            errors: {},
                            touched: {},
                          }}
                        />
                      ) : selectedOption === "ModifiedBy" ? (
                        <Dropdown>
                          {selectFieldOptions.map((opt: any) => (
                            <Option key={opt.value} value={opt.value}>
                              {opt.label}
                            </Option>
                          ))}
                        </Dropdown>
                      ) : types.toString() === "uuid" ? (
                        <Dropdown />
                      ) : types.toString() === "string" ? (
                        <div style={{ zIndex: 999 }}>
                          <CreatableSelect
                            isClearable
                            isLoading={loadCreatable}
                            options={clientDetail}
                            onChange={(newValue) =>
                              setSelectedValue(newValue ? newValue.value : null)
                            }
                          />
                        </div>
                      ) : (
                        <Input
                          onChange={(e) => {
                            handleValue(e, { value: e.target.value });
                          }}
                          name="selectedValue"
                          type={
                            types.toString() === "number" ? "number" : "text"
                          }
                          placeholder={
                            types.toString() === "number" ? "Number" : "Value"
                          }
                          value={selectedValue}
                        />
                      )}
                    </Field>

                    <div style={{ marginTop: "23px" }}>
                      <ASCButton
                        shape="rounded"
                        style={{ backgroundColor: "#0f6cbd" }}
                        appearance="primary"
                        className="asc-button-primary"
                        onClick={handleAddCondition}
                        label="Add condition"
                      />
                    </div>
                  </div>

                  {showDialogPopup && (
                    <>
                      <div
                        style={{
                          display: "grid",
                          gridTemplateColumns: "2fr 2fr 2fr 1fr",
                          margin: "5px",
                        }}
                      >
                        <div></div>
                        <Field>
                          <Dropdown
                            onOptionSelect={handleCondition}
                            name="selectedCondition"
                            placeholder="Condition"
                            value={selectedCondition}
                          >
                            {isCondition.map((x) => (
                              <Option key={x.id}>{x.name}</Option>
                            ))}
                          </Dropdown>
                        </Field>
                        <div></div>
                        <div></div>
                      </div>

                      <div className={styles.inlineContainer}>
                        <Field
                          label={
                            <span>
                              Field
                              {selectedCondition &&
                                selectedCondition.length > 0 && (
                                  <span className="required-item">*</span>
                                )}
                            </span>
                          }
                          validationState={
                            validationErrors.selectConditionOption
                              ? "error"
                              : "none"
                          }
                          validationMessage={
                            validationErrors.selectConditionOption || ""
                          }
                        >
                          <Dropdown
                            open={isDrodownExpanded}
                            onClick={toggleConditionDropdown}
                            name="selectConditionOption"
                            onOptionSelect={(value) => {
                              handleConditionTreeData(value);
                              setValidationErrors((prevErrors) => ({
                                ...prevErrors,
                                selectConditionOption: "",
                              }));
                            }}
                            placeholder={isConditionDataLabel || "Field"}
                            onOpenChange={handleDropdownToggle}
                            className="custom-dropdown"
                          >
                            <Tree
                              aria-label="Dynamic Tree"
                              key={treeConditionKey}
                              className="custom-tree"
                            >
                              {renderConditionTree(
                                extractData,
                                handleConditionOptionClick,
                              )}
                            </Tree>
                          </Dropdown>
                        </Field>
                        <Field
                          label={
                            <span>
                              Operator
                              {selectedCondition &&
                                selectedCondition.length > 0 && (
                                  <span className="required-item">*</span>
                                )}
                            </span>
                          }
                          validationState={
                            validationErrors.selectedConditionOperator
                              ? "error"
                              : "none"
                          }
                          validationMessage={
                            validationErrors.selectedConditionOperator || ""
                          }
                        >
                          <Dropdown
                            onOptionSelect={(e, value) => {
                              handleConditionOperator(e, value);
                              setValidationErrors({
                                ...validationErrors,
                                selectedConditionOperator: "",
                              });
                            }}
                            name="selectedConditionOperator"
                            placeholder={
                              selectedConditionOperator || "Operator"
                            }
                          >
                            {getConditionOperators().map((option) => (
                              <Option key={option.value} value={option.value}>
                                {option.label}
                              </Option>
                            ))}
                          </Dropdown>
                        </Field>

                        <Field label={<span>Value</span>}>
                          {conditionDataType.toString() === "timestamp" ? (
                            <DynamicDatePicker
                              name="selectedConditionValue"
                              label={null}
                              required={false}
                              disabled={false}
                              formik={{
                                values: {
                                  selectedConditionValue: selectedConditionValue
                                    ? new Date(selectedConditionValue)
                                    : null,
                                },
                                setFieldValue: (
                                  _name: string,
                                  value: Date | null,
                                ) => {
                                  handleSelectConditionDate(value);
                                },
                                setFieldTouched: () => { },
                                setFieldError: () => { },
                                errors: {},
                                touched: {},
                              }}
                            />
                          ) : conditionDataType.toString() === "uuid" ? (
                            <Dropdown placeholder="" />
                          ) : selectConditionOption === "ModifiedBy" ? (
                            <Dropdown>
                              {selectFieldOptions.map((opt: any) => (
                                <Option key={opt.value} value={opt.value}>
                                  {opt.label}
                                </Option>
                              ))}
                            </Dropdown>
                          ) : conditionDataType.toString() === "string" ? (
                            <div style={{ zIndex: 999 }}>
                              <CreatableSelect
                                isClearable
                                isLoading={loadCreatableCondition}
                                options={conditionPopulation}
                                onChange={(newValue) =>
                                  setSelectedConditionValue(
                                    newValue ? newValue.value : null,
                                  )
                                }
                              />
                            </div>
                          ) : (
                            <Input
                              onChange={(e) => {
                                handleConditionValue(e, {
                                  value: e.target.value,
                                });
                              }}
                              type={
                                conditionDataType.toString() === "number"
                                  ? "number"
                                  : "text"
                              }
                              name="selectedConditionValue"
                              placeholder={
                                conditionDataType.toString() === "number"
                                  ? "Number"
                                  : "Value"
                              }
                              value={selectedConditionValue}
                            />
                          )}
                        </Field>
                        <div style={{ marginTop: "23px" }}>
                          <ASCButton
                            shape="rounded"
                            style={{ backgroundColor: "#0f6cbd" }}
                            appearance="primary"
                            className="asc-button-primary"
                            onClick={handleDeleteCondition}
                            disabled={isDeleted}
                            label="Delete"
                          />
                        </div>
                      </div>
                    </>
                  )}
                  <Checkbox
                    checked={checked}
                    onChange={handleCheckboxChange}
                    label="Visible to all Users"
                  />
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "flex-end",
                      gap: "5px",
                      margin: "10px",
                    }}
                  >
                    <ASCButton
                      shape="rounded"
                      appearance="secondary"
                      onClick={handleClose}
                      label="Cancel"
                    />
                    <ASCButton
                      shape="rounded"
                      style={{ backgroundColor: "#0f6cbd" }}
                      onClick={handleSave}
                      appearance="primary"
                      className="asc-button-primary"
                      label="Save"
                      disabled={hasErrors}
                    />
                    <ASCButton
                      shape="rounded"
                      style={{ backgroundColor: "#0f6cbd" }}
                      onClick={handleSaveAndApply}
                      appearance="primary"
                      className="asc-button-primary"
                      label="Save and Apply"
                      disabled={hasErrors}
                    />
                  </div>
                </div>
              )}
            </div>
            <div style={{ margin: 12 }}>
              <MaterialReactTable
                columns={tableColumnList.extractList}
                data={extract}
                enableRowSelection={true}
                onRowSelectionChange={setRowSelection}
                enableMultiRowSelection={false}
                muiSelectCheckboxProps={{ style: { display: "none" } }}
                muiSelectAllCheckboxProps={{ style: { display: "none" } }}
                muiTableBodyRowProps={({ row }) => ({
                  onClick: () => {
                    setSelectedRow(row.original);
                  },
                  sx: { cursor: "pointer" },
                })}
                enableRowActions={true}
                displayColumnDefOptions={{
                  "mrt-row-actions": {
                    header: "Actions",
                    muiTableHeadCellProps: {
                      align: "center",
                    },
                    muiTableBodyCellProps: {
                      align: "center",
                    },
                  },
                }}
                renderRowActions={({ row }) => (
                  <div className={styles.wrapper}>
                    <Tooltip
                      content="Edit"
                      relationship="label"
                      positioning="below"
                    >
                      <ASCButton
                        shape="rounded"
                        appearance="subtle"
                        onClick={() => {
                          changeMode("edit", row.original);
                        }}
                        icon={
                          <Edit16Filled
                            primaryFill="var(--button-color)"
                          />
                        }
                      />
                    </Tooltip>
                    <Tooltip
                      content="Delete"
                      relationship="label"
                      positioning="below"
                    >
                      <ASCButton
                        shape="rounded"
                        appearance="subtle"
                        style={{ color: "red" }}
                        icon={<Delete16Regular />}
                        onClick={() => {
                          dispatch(
                            setDialogModalOptions({
                              open: true,
                              content_line_1: `Do you want to delete "${row.original.Title}"?`,
                              no: {
                                onclick: () => {
                                  dispatch(
                                    setDialogModalOptions({ open: false }),
                                  );
                                },
                                label: "No",
                                type: "secondary",
                              },
                              cancel: {
                                onclick: () => {
                                  deleteData(row.original);
                                },
                                label: "Yes",
                                type: "primary",
                              },
                            }),
                          );
                        }}
                      />
                    </Tooltip>
                  </div>
                )}
                initialState={{
                  columnPinning: { right: ["mrt-row-actions"] },
                }}
                positionActionsColumn="last"
                positionToolbarAlertBanner="bottom"
                state={{ rowSelection }}
              />
            </div>
          </div>
        ) : mode === "add" ? (
          <div>
            <h3>{mode === "add" ? "Add Search" : "Edit Search"}</h3>
            <div
              style={{
                margin: "10px 0",
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "10px",
              }}
            >
              <Field
                label={
                  <span>
                    Title<span className="required-item">*</span>
                  </span>
                }
                validationState={validationErrors.titleData ? "error" : "none"}
                validationMessage={validationErrors.titleData || ""}
              >
                <Input
                  value={titleData}
                  name="titleData"
                  onChange={(e) => {
                    handleTitleChange("titleData", e);
                    setValidationErrors({
                      ...validationErrors,
                      titleData: "",
                    });
                  }}
                />
              </Field>

              <Field label="Description">
                <Input
                  value={descriptionData}
                  name="descriptionData"
                  onChange={handleDescriptionChange}
                />
              </Field>
            </div>
            <div className={styles.inlineContainer}>
              <Field label="Field">
                <Dropdown
                  open={isDrodownExpand}
                  onClick={toggleDropdown}
                  name="selectedOption"
                  onOptionSelect={handleTreeData}
                  placeholder={isDataLabel || "Field"}
                  onOpenChange={handleDropdownToggle}
                  className="custom-dropdown"
                >
                  <Tree
                    aria-label="Dynamic Tree"
                    key={treeKey}
                    className="custom-tree"
                  >
                    {renderTree(extractData, handleOptionClick)}
                  </Tree>
                </Dropdown>
              </Field>

              <Field
                label={
                  <span>
                    Operator
                    {((Array.isArray(selectedOption) &&
                      selectedOption.length > 0) ||
                      (typeof selectedOption === "string" && selectedOption) ||
                      (typeof selectedOption === "number" &&
                        selectedOption !== 0)) && (
                        <span className="required-item">*</span>
                      )}
                  </span>
                }
                validationState={
                  validationErrors.selectedOperator ? "error" : "none"
                }
                validationMessage={validationErrors.selectedOperator || ""}
              >
                <Dropdown
                  name="selectedOperator"
                  placeholder={selectedOperator || "Operator"}
                  onOptionSelect={(e, value) => {
                    handleOperator(e, value);
                    setValidationErrors({
                      ...validationErrors,
                      selectedOperator: "",
                    });
                  }}
                >
                  {getOperators().map((opt) => (
                    <Option key={opt.value} value={opt.value}>
                      {opt.label}
                    </Option>
                  ))}
                </Dropdown>
              </Field>
              <Field label={<span>Value</span>}>
                {types.toString() === "timestamp" ? (
                  <DynamicDatePicker
                    border
                    name="selectedValue"
                    label={null}
                    required={false}
                    disabled={false}
                    formik={{
                      values: {
                        selectedValue: selectedValue
                          ? new Date(selectedValue)
                          : null,
                      },
                      setFieldValue: (_name: string, value: Date | null) => {
                        handleSelectDate(value);
                      },
                      setFieldTouched: () => { },
                      setFieldError: () => { },
                      errors: {},
                      touched: {},
                    }}
                  />
                ) : selectedOption === "ModifiedBy" ? (
                  <Dropdown>
                    {selectFieldOptions.map((opt: any) => (
                      <Option key={opt.value} value={opt.value}>
                        {opt.label}
                      </Option>
                    ))}
                  </Dropdown>
                ) : types.toString() === "uuid" ? (
                  <Dropdown />
                ) : types.toString() === "string" ? (
                  <div style={{ zIndex: 999 }}>
                    <CreatableSelect
                      isClearable
                      isLoading={loadCreatable}
                      options={clientDetail}
                      onChange={(newValue) =>
                        setSelectedValue(newValue ? newValue.value : null)
                      }
                    />
                  </div>
                ) : (
                  <Input
                    onChange={(e) => {
                      handleValue(e, { value: e.target.value });
                    }}
                    name="selectedValue"
                    type={types.toString() === "number" ? "number" : "text"}
                    placeholder={
                      types.toString() === "number" ? "Number" : "Value"
                    }
                    value={selectedValue}
                  />
                )}
              </Field>

              <div style={{ marginTop: "23px" }}>
                <ASCButton
                  shape="rounded"
                  style={{ backgroundColor: "#0f6cbd" }}
                  appearance="primary"
                  className="asc-button-primary"
                  onClick={handleAddCondition}
                  label="Add condition"
                />
              </div>
            </div>

            {showDialogPopup && (
              <>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "2fr 2fr 2fr 1fr",
                    margin: "5px",
                  }}
                >
                  <div></div>
                  <Field>
                    <Dropdown
                      onOptionSelect={handleCondition}
                      name="selectedCondition"
                      placeholder="Condition"
                      value={selectedCondition}
                    >
                      {isCondition.map((x) => (
                        <Option key={x.id}>{x.name}</Option>
                      ))}
                    </Dropdown>
                  </Field>
                  <div></div>
                  <div></div>
                </div>

                <div className={styles.inlineContainer}>
                  <Field
                    label={
                      <span>
                        Field
                        {selectedCondition && selectedCondition.length > 0 && (
                          <span className="required-item">*</span>
                        )}
                      </span>
                    }
                    validationState={
                      validationErrors.selectConditionOption ? "error" : "none"
                    }
                    validationMessage={
                      validationErrors.selectConditionOption || ""
                    }
                  >
                    <Dropdown
                      open={isDrodownExpanded}
                      onClick={toggleConditionDropdown}
                      name="selectConditionOption"
                      onOptionSelect={(value) => {
                        handleConditionTreeData(value);
                        setValidationErrors((prevErrors) => ({
                          ...prevErrors,
                          selectConditionOption: "",
                        }));
                      }}
                      placeholder={isConditionDataLabel || "Field"}
                      onOpenChange={handleDropdownToggle}
                      className="custom-dropdown"
                    >
                      <Tree
                        aria-label="Dynamic Tree"
                        key={treeConditionKey}
                        className="custom-tree"
                      >
                        {renderConditionTree(
                          extractData,
                          handleConditionOptionClick,
                        )}
                      </Tree>
                    </Dropdown>
                  </Field>
                  <Field
                    label={
                      <span>
                        Operator
                        {selectedCondition && selectedCondition.length > 0 && (
                          <span className="required-item">*</span>
                        )}
                      </span>
                    }
                    validationState={
                      validationErrors.selectedConditionOperator
                        ? "error"
                        : "none"
                    }
                    validationMessage={
                      validationErrors.selectedConditionOperator || ""
                    }
                  >
                    <Dropdown
                      onOptionSelect={(e, value) => {
                        handleConditionOperator(e, value);
                        setValidationErrors({
                          ...validationErrors,
                          selectedConditionOperator: "",
                        });
                      }}
                      name="selectedConditionOperator"
                      placeholder={selectedConditionOperator || "Operator"}
                    >
                      {getConditionOperators().map((option) => (
                        <Option key={option.value} value={option.value}>
                          {option.label}
                        </Option>
                      ))}
                    </Dropdown>
                  </Field>

                  <Field label={<span>Value</span>}>
                    {conditionDataType.toString() === "timestamp" ? (
                      <DynamicDatePicker
                        name="selectedConditionValue"
                        label={null}
                        required={false}
                        disabled={false}
                        formik={{
                          values: {
                            selectedConditionValue: selectedConditionValue
                              ? new Date(selectedConditionValue)
                              : null,
                          },
                          setFieldValue: (
                            _name: string,
                            value: Date | null,
                          ) => {
                            handleSelectConditionDate(value);
                          },
                          setFieldTouched: () => { },
                          setFieldError: () => { },
                          errors: {},
                          touched: {},
                        }}
                      />
                    ) : conditionDataType.toString() === "uuid" ? (
                      <Dropdown placeholder="" />
                    ) : selectConditionOption === "ModifiedBy" ? (
                      <Dropdown>
                        {selectFieldOptions.map((opt: any) => (
                          <Option key={opt.value} value={opt.value}>
                            {opt.label}
                          </Option>
                        ))}
                      </Dropdown>
                    ) : conditionDataType.toString() === "string" ? (
                      <div style={{ zIndex: 999 }}>
                        <CreatableSelect
                          isClearable
                          isLoading={loadCreatableCondition}
                          options={conditionPopulation}
                          onChange={(newValue) =>
                            setSelectedConditionValue(
                              newValue ? newValue.value : null,
                            )
                          }
                        />
                      </div>
                    ) : (
                      <Input
                        defaultValue={selectedConditionValue}
                        onChange={(e) => {
                          handleConditionValue(e, {
                            value: e.target.value,
                          });
                        }}
                        type={
                          conditionDataType.toString() === "number"
                            ? "number"
                            : "text"
                        }
                        name="selectedConditionValue"
                        placeholder={
                          conditionDataType.toString() === "number"
                            ? "Number"
                            : "Value"
                        }
                        value={selectedConditionValue}
                      />
                    )}
                  </Field>
                  <div style={{ marginTop: "23px" }}>
                    <ASCButton
                      shape="rounded"
                      style={{ backgroundColor: "#0f6cbd" }}
                      appearance="primary"
                      className="asc-button-primary"
                      onClick={handleDeleteCondition}
                      disabled={isDeleted}
                      label="Delete"
                    />
                  </div>
                </div>
              </>
            )}
            <Checkbox
              checked={checked}
              onChange={handleCheckboxChange}
              label="Visible to all Users"
            />
            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "5px",
                margin: "10px",
              }}
            >
              <ASCButton
                shape="rounded"
                appearance="secondary"
                onClick={handleClose}
                label="Cancel"
              />
              <ASCButton
                shape="rounded"
                style={{ backgroundColor: "#0f6cbd" }}
                onClick={handleSave}
                appearance="primary"
                className="asc-button-primary"
                label="Save"
                disabled={hasErrors}
              />
              <ASCButton
                shape="rounded"
                style={{ backgroundColor: "#0f6cbd" }}
                onClick={handleSaveAndApply}
                appearance="primary"
                className="asc-button-primary"
                label="Save and Apply"
                disabled={hasErrors}
              />
            </div>
          </div>
        ) : (
          <NoDataFound />
        )}
      </div>
    </>
  );
};
